const checkIfResponseIsOk = (statusCode: number): boolean => {
  return statusCode.toString().startsWith('2');
};

export default checkIfResponseIsOk;
